<script lang="ts">
	import { page } from '$app/stores';
	import { activeWallet, keycloak } from '$lib/stores/userstore';
	import NavigationItem from './NavigationItem.svelte';
	import TabBar from './TabBar.svelte';

</script>

<TabBar>
	<NavigationItem text="Wallet" href="/user/wallet" pathname={$page.url.pathname} />
	{#if !!$activeWallet}
		<NavigationItem text="Inventory" href="/user/inventory" pathname={$page.url.pathname} />
		<NavigationItem text="Staking" href="/user/staking" pathname={$page.url.pathname} />
		<NavigationItem text="Trading" href="/user/trading" pathname={$page.url.pathname} />
	{/if}
	{#if !!$keycloak}
		<NavigationItem text="Wishlist" href="/user/wishList" pathname={$page.url.pathname} />
	{/if}
	<NavigationItem text="History" href="/user/history" pathname={$page.url.pathname} />
</TabBar>
